import React from 'react';
import { slideWrapper } from '../components/slide';
import { PuzzleItem, PuzzleItemsWrapper } from '../components/puzzle-item';
import { Timer } from '../components/timer';

import { Content } from '../components/content';
import { SlideImage } from '../components/slide-image';
import { useConfirmation } from '../../generic/hooks/use-confirmation';

export const LeonardoPuzzle2 = slideWrapper(({ step, data, getImg, ...props }) => {
  const { answers } = step;

  const ConfirmationPopup = useConfirmation(1);
  return (
    <>
      <ConfirmationPopup />
      <Content left={15} bottom={-30} yNotCenter>
        <SlideImage width="400px" src={getImg('balon-color')} show={true} />
      </Content>
      <Timer data={data} presentation />
      <PuzzleItemsWrapper>
        <PuzzleItem getImg={getImg} letter="a" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="b" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="c" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="d" answers={answers} smallItem />
        <PuzzleItem getImg={getImg} letter="e" answers={answers} smallItem />
      </PuzzleItemsWrapper>
    </>
  );
});
